module.exports = __webpack_public_path__ + "static/media/spot3.41e87dd5.png";